import { lazy, Suspense, useState } from 'react';
import { faCheck, faAngleDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CSS from 'csstype';

import CounterComponent from '../../components/counter/CounterComponent';
import ViewMapComponent from '../../components/maps/ViewMapComponent';
import GeneralButtonComponent from '../../components/button/GeneralButtonComponent';
import { SliderImages } from '../../components/swipper/SliderImages';
import { HeadLine } from '../../layouts/headers/HeadLine';
import { msgWarnStyle } from './ToursMainPage';
import { useAlert } from '../../hooks/useAlert';
import TourAlertTemplate from './components/TourAlertTemplate';

export const TourDetailPage = () => {

    const [modalSwitch, setModalSwitch] = useState({ state: false, selected: 0 });

    const ImageVisualizer = lazy(() => import('./../../components/swipper/ImageVisualizer'));

    const checkIcon = <FontAwesomeIcon icon={faCheck} color='#67BAAF' />
    const angleDown = <FontAwesomeIcon icon={faAngleDown} color='#67BAAF' size='2x' />

    const alert = useAlert('¡Gracias por reservar esta actividad!');

    const handlePedido = () => {
        alert.fire(<TourAlertTemplate onclose={()=>{alert.close()}} />);
    }

    const images = [
        '/assets/img/tours_7.png',
        '/assets/img/tours_8.png',
        '/assets/img/tours_9.png',
        '/assets/img/tours_10.png'
    ];

    const handleClickImage = (e) => {
        setModalSwitch({ state: true, selected: e.clickedIndex });
    }

    return (
        <div>
            <div className='w-full absolute z-1 head-hi-sm flex flex-col justify-center'>
                <HeadLine title='Tours & Excursiones' backurl='../' />
            </div>

            <div className="w-full relative content-hi-sm">
                <div className="flex justify-center items-center" style={msgWarnStyle}>
                    <span >El cobro del servicio se realizará a tu tarjeta de crédito registrada</span>
                </div>
            </div>

            <div className='tour-detail-container'>
                <SliderImages items={images} onclickitem={handleClickImage} />

                <div style={titleStyles}>Paquete Experiencias Xcaret</div>

                <div className='inline-flex mt-4 smalltxt' style={{ fontSize: '14px' }}><img src="/assets/img/icons/location-icon.svg" width={'15px'} alt="location" /> &nbsp; Playa del Carmen</div>

                <div className='flex justify-end mb-4'>

                    <div className='flex flex-col items-end'>
                        <span className='smalltxt'>por Persona</span>
                        <span className='price mt-2 mb-2'>MXN 2,145</span>
                        <span className='smalltxt'>Imp. ya incluidos</span>
                    </div>
                </div>

                <div className='line'></div>

                <div className='mt-8 features'>
                    <div className='flex justify-between items-center'>
                        <span className='inline-flex items-center'>
                            <img src="/assets/img/icons/clock-icon.svg" width={'25.5px'} alt="location" /> &nbsp;<strong>Duración del Tour:</strong>
                        </span>
                        <span>
                            10 horas
                        </span>
                    </div>
                    <div className='flex justify-between mt-4 items-center'>
                        <span className='inline-flex items-center'>
                            <img src="/assets/img/icons/bus-icon.svg" width={'25.5px'} alt="location" /> &nbsp; <strong>Salida del Transporte:</strong>
                        </span>
                        <span>
                            7:00 a.m.
                        </span>
                    </div>
                    <div className='flex justify-between mt-4 items-center'>
                        <span className='inline-flex items-center'>
                            <img src="/assets/img/icons/location-icon.svg" width={'25.5px'} alt="location" /> &nbsp; <strong>Punto de encuentro:</strong>
                        </span>
                        <span>
                            Lobby del Hotel
                        </span>
                    </div>
                </div>

                <div className='mt-8 mb-8' style={{ color: '#4B5563', fontSize: '14px' }}>
                    <p >
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidi...
                    </p>
                    <br />
                    <div className='text-center flex justify-center items-center gap-1'><span>Más detalles</span> {angleDown}</div>
                </div>

                <div className="line"></div>
                <div className='mt-8 mb-8' style={titleStyles}>Ubicacion de la actividad</div>
                <ViewMapComponent />

                <div className="line"></div>

                <div className='mt-8' style={titleStyles}>Recomendaciones</div>

                <div className='mt-4 mb-8'>
                    <div>
                        {checkIcon} Se recomienda llevar ropa de playa, traje de baño, sandalias o zapatos para agua, lentes de sol y gorra o sombrero.
                    </div>
                    <div className='mt-4'>
                        {checkIcon} Llevar bloqueador solar y repelente de insectos biodegradables.
                    </div>
                    <div className='mt-4'>
                        {checkIcon} Algunas actividades tienen restricciones médicas y de edad.
                    </div>
                </div>

                <div className="line"></div>

                <div className='tour-detail-options mt-8 shadow-xl'>
                    <div className='flex justify-between items-center'>
                        <span>Fecha de tour:</span>
                        <div className="inline-block relative" style={{ width: '166px' }}>
                            <select className="block appearance-none w-full bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded-lg shadow leading-tight focus:outline-none focus:shadow-outline"
                                style={{ height: '50px' }}>
                                <option>1 - Dic - 2021</option>
                                <option>2 - Dic - 2021</option>
                                <option>3 - Dic - 2021</option>
                            </select>
                            <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                                <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" /></svg>
                            </div>
                        </div>
                    </div>
                    <div className='flex justify-between items-center mt-8'>
                        <span>Número de Personas:</span>
                        <CounterComponent />
                    </div>
                </div>

                <div className='flex justify-end mt-8 mb-8'>
                    <div className='flex flex-col items-end mr-8'>
                        <span className='smalltxt' style={{ 'fontSize': '14px' }}>TOTAL</span>
                        <span className='price mt-2'>MXN 4,290</span>
                    </div>

                    <div>
                        <GeneralButtonComponent classes='primary_btn hover:primary_btn text-white py-3 px-6 he-50' bgcolor='#67BAAF' click={handlePedido} >Reservar</GeneralButtonComponent>
                    </div>
                </div>
            </div>

            {
                modalSwitch.state && (
                    <Suspense fallback={<div>...</div>}>
                        <ImageVisualizer onclose={() => { setModalSwitch({ state: false, selected: 0 }) }} items={images} initial={modalSwitch.selected} />
                    </Suspense>
                )
            }

        </div>
    );
};


const titleStyles: CSS.Properties = {
    fontSize: '18px',
    fontWeight: '600',
    color: '#012349',
    lineHeight: '18px'
}